import { Flex, Text } from '@cad-arc';
import { DexResultView } from '@mark43/dex-api';
import { ResultImageLine } from '../result-image-line';
import { ResultLineWithDrilldownLink } from './result-line-with-drilldown-link';

export function ResultLines({
    result,
    originatingQueryOriAliasId,
}: Readonly<{
    result: DexResultView;
    originatingQueryOriAliasId?: number;
}>): React.ReactElement {
    const hasImage = !!result.mark43FilePath;
    return (
        <Flex direction="column">
            {result.mark43File ? (
                <ResultLine
                    key={1}
                    lineNumber={1}
                    line={<ResultImageLine mark43File={result.mark43File} />}
                />
            ) : undefined}
            {result.messageLines.map((line, i) => {
                const lineNumber = hasImage ? i + 2 : i + 1;
                const drilldownOption = result.drilldownOptions.find(
                    (option) => option.rowIndex === i
                );
                return (
                    <ResultLine
                        key={lineNumber}
                        lineNumber={lineNumber}
                        line={
                            <ResultLineWithDrilldownLink
                                originatingQueryOriAliasId={originatingQueryOriAliasId}
                                line={line}
                                drilldownOption={drilldownOption}
                            />
                        }
                    />
                );
            })}
        </Flex>
    );
}

function ResultLine({
    lineNumber,
    line,
}: Readonly<{
    lineNumber: number;
    line: React.ReactNode;
}>): React.ReactElement {
    return (
        <Flex alignItems="stretch" w="100%">
            <Text
                as="span"
                color="secondary"
                fontFamily="mono"
                variant="bodyMd"
                style={{
                    userSelect: 'none',
                    marginRight: '20px',
                    textAlign: 'right',
                    minWidth: '30px',
                }}
            >
                {lineNumber}
            </Text>
            {line}
        </Flex>
    );
}
